import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { flushSync } from "react-dom";
import axios from "axios";

const AuthContext = createContext();

// Authentication temporarily disabled — a default super_admin is installed
// automatically so every page that gates on `useAuth().user` works out of
// the box, and login/logout are no-ops.
const DEFAULT_ADMIN = {
  user_id: "default_super_admin",
  email: "admin@local",
  name: "Admin",
  role: "super_admin",
  auth_provider: "open",
  is_active: true,
  picture: null,
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(DEFAULT_ADMIN);
  const [loading, setLoading] = useState(false);

  const checkAuth = useCallback(async () => {
    setUser(DEFAULT_ADMIN);
    setLoading(false);
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const login = async () => {
    setUser(DEFAULT_ADMIN);
    return DEFAULT_ADMIN;
  };

  const loginWithGoogle = async () => {
    setUser(DEFAULT_ADMIN);
    return DEFAULT_ADMIN;
  };

  const logout = async () => {
    // No-op while auth is disabled — stay logged in as the default admin.
    setUser(DEFAULT_ADMIN);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, loginWithGoogle, logout, checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
